module.exports = __webpack_public_path__ + "static/media/icon_key.3c491112.png";